<template>
	<main class="vx-row lg:mb-8">
		<div 
			class="vx-col w-full md:w-1/2 lg:w-1/4"
			v-for="(item, i) in data"
			:key="i"
		>
			<vx-card class="mb-8">
				<div slot="no-body">
					<router-link :to="`/news/${item.id}/detail`">
					<img :src="imageLink(item)" alt="Campaign" class="responsive card-img-top" />
					</router-link>
				</div>
				<router-link :to="`/news/${item.id}/detail`">
					<h5 class="mb-2"><strong>{{ item.name }}</strong></h5>
					<div class="flex justify-between items-center">
					</div>
				</router-link>
			</vx-card>
		</div>
	</main>
</template>
<script>
export default {
  props: ['data'],
  methods: {
    imageLink (item) {
      return `${item  }https://dev-storage.zax.co.id/upload//jpeg/F-1645166377.jpeg`
    }
  }
}
</script>